export default __webpack_public_path__ + "images/OZ.4e396f8.png";